import React from 'react'
import { useNavigate } from 'react-router-dom'

const Singlemovie = ({data}) => {
const navigate = useNavigate()
  return (
   

   
    <div id='singleMovie-container'>
   <img src={`/asset/${data.image}`}/>
   <h6 onClick={()=>navigate(`/Allmovie/${data.id}`)}>{data.title}</h6>
   
    </div>
  )
}

export default Singlemovie